import ArrowRight from '@sats-group/icons/24/arrow-right';
import Text from '@sats-group/ui-lib/react/text';
import cn from 'classnames';
import React from 'react';
import CleanLink from '../clean-link/clean-link';
import ContentContainer from '../content-container/content-container';
import { type Breadcrumbs as Props, themes } from './breadcrumbs.types';

const Breadcrumbs: React.FunctionComponent<Props> & {
  themes: typeof themes;
} = ({ theme = themes.light, landmarkLabel, links, title, width }) => (
  <nav aria-label={landmarkLabel} className="breadcrumbs">
    <ContentContainer theme={width ? width : ContentContainer.themes.wide}>
      <ol className={cn('breadcrumbs__list', `breadcrumbs__list--${theme}`)}>
        {links.map((link, index) => (
          <li className="breadcrumbs__item" key={`${index}-${link.text}`}>
            {index === 0 ? null : (
              <div className="breadcrumbs__icon">
                <ArrowRight />
              </div>
            )}
            {link.href ? (
              <CleanLink
                className={cn(
                  'breadcrumbs__link',
                  `breadcrumbs__link--${theme}`
                )}
                href={link.href}
                text={link.text}
                theme={CleanLink.themes.noUnderline}
                bold
              />
            ) : (
              <span className="breadcrumbs__text">
                <Text theme={Text.themes.emphasis} size={Text.sizes.small}>
                  {link.text}
                </Text>
              </span>
            )}
          </li>
        ))}
        <li aria-current="page" className="breadcrumbs__item">
          <div className="breadcrumbs__icon">
            <ArrowRight />
          </div>
          <span className="breadcrumbs__text">
            <Text theme={Text.themes.emphasis} size={Text.sizes.small}>
              {title}
            </Text>
          </span>
        </li>
      </ol>
    </ContentContainer>
  </nav>
);

Breadcrumbs.themes = themes;

export default Breadcrumbs;
